// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"Container_PageWrapper__3cVeZ"};